import { PropsWithChildren, useCallback, useState } from 'react';
import { ProductViewModel } from '@/types/api';
import { BabyPDPVariantContext } from './context';
import { useProductVariantCore } from '../use-product-variant-core';
interface Props extends PropsWithChildren {
  product?: ProductViewModel;
  isLoading: boolean;
}
const BabyPDPVariantProvider = ({
  children,
  product,
  isLoading
}: Props) => {
  const [selectedAtpId, setSelectedAtpId] = useState<string | null>(null);
  const variantUpdateHandler = useCallback((atpId: string | null) => {
    setSelectedAtpId(atpId);
  }, []);
  const coreValues = useProductVariantCore({
    product,
    isLoading,
    selectedAtpId,
    variantUpdateHandler
  });
  return <BabyPDPVariantContext.Provider value={coreValues} data-sentry-element="unknown" data-sentry-component="BabyPDPVariantProvider" data-sentry-source-file="provider.tsx">{children}</BabyPDPVariantContext.Provider>;
};
export default BabyPDPVariantProvider;